import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { ROUTES } from "../../lib/constants";
import styles from "./ReferralProgram.module.scss";
import { LogosCarousel } from "../../components/LogosCarousel/LogosCarousel";
import { Image } from "../../components/Image/Image";
import { ReferralForm } from "./ReferralForm";
import { Button } from "../../components/Button/Button";
import imageM from "../../images/referral-page-m.jpg";
import imageD from "../../images/referral-page-d.jpg";
import { SVGIcon } from "../../components/SVGIcon/SVGIcon";
/* import { Link } from "react-router-dom"; */

export const ReferralProgram = (): React.JSX.Element => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Helmet>
        <title>{ROUTES.referralProgram.title}</title>
        <meta
          name="description"
          content="Cityside Fiber’s referral program offers fantastic benefits to you and your friends when they use your code to make the switch."
        />

        <meta property="og:title" content={`${ROUTES.referralProgram.title}`} />
        <meta property="og:description" content="Cityside Fiber’s referral program offers fantastic benefits to you and your friends when they use your code to make the switch." />
        <meta property="og:url" content="https://www.citysidefiber.com/referral-program" />
      </Helmet>

      <section className={styles.hero}>
        <div className={styles.designElement}></div>

        <div className="grid-12">
          <div className={styles.container}>
            <h1 className="headline__h1 color--daylight-blue">
              Residential Referral Program
            </h1>

            <p className="headline__h3 color--marina-blue">
              Refer a Friend and Both of You Save!
            </p>
          </div>
        </div>
      </section>

      <section className={styles.main}>
        <div className={styles.waves}></div>

        <div className="grid-12">
          <div className={styles.container}>
            <div className={styles.image}>
              <Image
                sources={[
                  {
                    src: imageM,
                    breakpoint: "default",
                  },
                  {
                    src: imageD,
                    breakpoint: "960px",
                  },
                ]}
                alt="two men on couch wtchng game with celebratory expressions"
              />
            </div>

            <div className={styles.benefits}>
              <h2 className="headline__h1 color--orange">The Benefits</h2>

              <p className="headline__h3">First</p>

              <ul>
                <li>1 Free month of service per referral</li>

                <li>Each person you refer also gets 1 month free</li>

                <li>Up to 3 standard referrals per year</li>
              </ul>

              <p className="headline__h3">Then</p>

              <ul>
                <li>
                  For each referral thereafter, you will get $20 credit on 1
                  month's bill (Your referred will get 1 month free)
                </li>
              </ul>
            </div>

            <ReferralForm />

            <div className={styles.giglife}>
              <h2 className="headline__h1 color--marina-blue">
                The Cityside Fiber
                <br />
                GIG LIFE™ Includes:
              </h2>

              <ul className="checkmark-list">
                <li>Concierge-level service from our local OC team</li>

                <li>True Gig speed Internet on upload and download</li>

                <li>
                  No long-term contracts or end-of-contract pricing gimmicks
                </li>

                <li>
                  Standard professional installation and WiFi router / modem
                  included
                </li>

                <li>
                  Seamless WiFi Smart Phone calling at home – inside, outside,
                  and poolside
                </li>

                <li>
                  Support your OC neighbors through Cityside’s community
                  sponsorships
                </li>
              </ul>

              <Button onClick={openModal} size="lg">
                Terms and Conditions
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.sponsors}>
        <h2 className="headline__h2 color--marina-blue">Proud Sponsors of</h2>

        <div className={styles.container}>
          <LogosCarousel />
        </div>
      </section>

      {/* Modal markup, conditionally rendered */}
      {isModalOpen && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.container}>
              <h1>Terms and Conditions<br />Cityside Fiber Referral Program</h1>

              <div className={styles.closeModal} onClick={closeModal}>
                <SVGIcon id="close" color="ui-black"/>
              </div>
              <section className={styles.content}>
                <h2>How it works</h2>

                <p>
                  Refer a friend, and you’ll both get One Free Month of Service credited to your accounts.
                </p>

                <ol>
                  <li>
                    Obtain your friend’s permission to provide us with their contact details on the referral page.
                  </li>

                  <li>
                    Once your friend signs up for service and pays their first bill, you and your friend will receive a credit for one month of service applied to each account.
                  </li>

                  <li>
                    Please keep referring!  You are eligible for up to three months of free service per year (i.e., 3 successful referrals).
                  </li>

                  <li>
                  After you have had 3 successful referrals in a 12-month period, you can keep referring friends and neighbors and be eligible to receive a one-time $20 monthly statement credit for each successful referral thereafter. The credit(s) will be applied to your account following your friend’s/ payment of their first bill. Plus, whomever you refer will get a Free Month of Service.
                  </li>
                </ol>

                <p data-bold>
                  **Cityside Fiber reserves the right to discontinue the Cityside Fiber Referral Program at any time.**
                </p>
              </section>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
